'use client';

import { useClientTranslation, useClientLocale } from '@bts-web/utils-lokalise';
import { intlFiatValueFormatting } from '@bts-web/utils-formatting';
import { ButtonBase, DialogBase } from '../../../../common';
import { getAppConfig } from '@bts-web/core-app-config';
import { FiatSymbolIcon } from '../../Reusable/FiatSymbolIcon/FiatSymbolIcon';
import { getWithdrawalConfirmationTranslations } from './getWithdrawalConfirmationTranslations';
import { PoweredByTextWithLogo } from '../../../Reusable/PoweredBy/PoweredBy';
import { bodyStyles, bottomSectionStyles } from '../../../../common/styles';
import {
  titleStyles,
  subtitleStyles,
  centeredContentStyles,
} from './withdrawalConfirmationStyles';
import { ModalComponent } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { useIsBelowScreenWidth } from '@bts-web/core-features/layouts';

interface WithdrawalConfirmationModalProps {
  amount: string | null;
  recipientName: string;
}

export const WithdrawalConfirmationModal: ModalComponent<
  WithdrawalConfirmationModalProps
> = ({ amount, recipientName, onClose }) => {
  const { t } = useClientTranslation();

  const locale = useClientLocale();

  const { currency } = getAppConfig();

  const isMobile = useIsBelowScreenWidth(1024);

  const formattedAmount = amount
    ? intlFiatValueFormatting(amount, { locale, currency })
    : null;

  const translations = getWithdrawalConfirmationTranslations(
    t,
    recipientName,
    formattedAmount,
  );

  return (
    <DialogBase
      id="withdrawal-confirmation-modal"
      onClose={onClose}
      size={isMobile ? 'fullscreen' : 'small'}
      visual="secondary"
      title={undefined}
    >
      <div className={bodyStyles}>
        <div className={centeredContentStyles}>
          <FiatSymbolIcon iconSize={75} containerSize={80} />

          <span className={titleStyles}>{translations.title}</span>

          <span className={subtitleStyles}>{translations.subtitle}</span>
        </div>

        <div className={bottomSectionStyles}>
          <PoweredByTextWithLogo noMargins />

          <ButtonBase
            data-testid="withdrawal-confirmation-ok-button"
            visual="accent"
            size="large"
            onClick={onClose}
            fullWidth
            noHover
          >
            {translations.okGotIt}
          </ButtonBase>
        </div>
      </div>
    </DialogBase>
  );
};
